package features.teams.ui.modals

import kotlinx.browser.document
import kotlinx.html.*
import kotlinx.html.dom.append
import kotlinx.html.js.onClickFunction
import org.w3c.dom.HTMLElement
import shared.ui.ModalManager
import AppState
import Router

object EditTeamNameModal {
    fun render(root: HTMLElement) {
        root.append {
            div("modal-content fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-dark-800 border border-dark-700 rounded-2xl p-6 w-full max-w-md z-[101] hidden shadow-2xl scale-95 opacity-0 transition-all duration-300") {
                id = "edit-team-name-modal"
                
                div("flex justify-between items-center mb-6") {
                    h3("text-xl font-bold") { +"Edit Team Name" }
                    button(classes = "text-slate-400 hover:text-white") {
                        onClickFunction = { ModalManager.close() }
                        +"✕"
                    }
                }
                
                div("mb-6") {
                    label("block text-sm text-slate-400 mb-2") { +"Team Name" }
                    input(classes = "w-full bg-dark-900 border border-dark-700 rounded-xl p-3 focus:outline-none focus:border-brand-cyan transition text-white") {
                        id = "edit-team-name-input"
                        placeholder = "Enter new team name"
                    }
                }
                
                div("flex justify-end gap-3") {
                    button(classes = "px-4 py-2 rounded-xl text-slate-300 hover:bg-dark-700 transition") {
                        onClickFunction = { ModalManager.close() }
                        +"Cancel"
                    }
                    button(classes = "px-4 py-2 rounded-xl bg-brand-cyan text-white hover:bg-brand-green transition") {
                        onClickFunction = {
                            val nameInput = document.getElementById("edit-team-name-input") as? org.w3c.dom.HTMLInputElement
                            val newName = nameInput?.value?.trim() ?: ""
                            val teamId = AppState.currentTeam?.id
                            
                            when {
                                newName.isEmpty() -> {
                                    kotlinx.browser.window.alert("Please enter a team name")
                                }
                                teamId == null -> {
                                    kotlinx.browser.window.alert("No team selected")
                                }
                                else -> {
                                    console.log("Updating team name to:", newName)
                                    features.teams.data.TeamRepository.updateTeamName(teamId, newName)
                                        .then {
                                            console.log("✅ Team name updated")
                                            
                                            // Update local state
                                            val team = AppState.teams.find { it.id == teamId }
                                            if (team != null) {
                                                val updatedTeam = team.copy(name = newName)
                                                val index = AppState.teams.indexOf(team)
                                                AppState.teams[index] = updatedTeam
                                                AppState.currentTeam = updatedTeam
                                            }
                                            
                                            ModalManager.close()
                                            Router.render()
                                        }
                                        .catch { error ->
                                            console.error("Error updating team name:", error)
                                            kotlinx.browser.window.alert("Failed to update team name")
                                        }
                                }
                            }
                        }
                        +"Save"
                    }
                }
            }
        }
    }
}
